import React, { useEffect } from "react";
import * as actionCreators from "./../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { Alert, Modal, Button, Fade } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { isNotProductive, putLogs } from "../../utilities";
import { urladmin } from "../../actions/webServices";
import SpinnerLoading from "../../Components/SpinnerLoading";
import axios from "axios";
import Base64Downloader from "common-base64-downloader-react";

const url = isNotProductive
  ? process.env.REACT_APP_CUSTOM_TEST_URL
  : process.env.REACT_APP_CUSTOM_URL;
const options = {
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
};

function Confirm({
  user,
  firstStep,
  payMethod,
  resetData,
  arrPayMethod,
  area,
  phone,
  codpmpol,
  company,
  titularData,
}) {
  const navigate = useNavigate();
  const params = new URLSearchParams();
  params.set("opcpm", "VerConfirmar");
  params.set("usuario", user.email);
  params.set("clave", user.password);
  params.set("token", user.token);
  params.set("codpmpol", codpmpol);

  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPolPDF, setCurrentPolPDF] = useState("");
  const [currentCupPDF, setCurrentCupPDF] = useState("");
  const [cerpol, setCerpol] = useState(0);
  const [intpol, setIntpol] = useState(0);
  const [constancia, setConstancia] = useState(true);

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const reset = () => {
    resetData(user.token);
    navigate("/");
    /*if (confirmed) {
      params.set('opcpm', "Emitir");
      axios.post(url, params, options)
        .finally(r => {
          // console.log('termino', r)
        })
    }*/
  };

  const getPDFPol = (cerpol) => {
    if (cerpol === 0) {
      setCurrentPolPDF("");
      return;
    }
    params.set("opcpm", "getPolicyPDF");
    params.set("cerpol", cerpol);
    axios.post(urladmin, params, options).then((r) => {
      setCurrentPolPDF(r.data);
    });
  };

  const getPDFCup = (propol) => {
    if (propol === 0) {
      setCurrentCupPDF("");
      return;
    }
    params.set("opcpm", "getCuponeraPDF");
    params.set("propol", propol);
    axios.post(urladmin, params, options).then((r) => {
      setCurrentCupPDF(r.data);
    });
  };

  const finish = () => {
    setLoading(true);
    if (firstStep.codsec === 27) {
      params.set("opcpm", "ConfirmaMawdy");
    };
    axios.post(url, params, options).then((r) => {
      if (r.data.codpmpol === "ok") {
        if (firstStep.payMethod === "3") getPDFCup(r.data.propol);
        getPDFPol(r.data.cerpol);
        setCerpol(r.data.cerpol);
        setIntpol(r.data.intpol);
        setMsg(
          `¡Compra completada! ${r.data.cerpol
            ? `Póliza dada de álta con N° ${r.data.cerpol}`
            : " Póliza en espera de confirmación de la compañía."
          }`
        );
        setConfirmed(true);
        if(r.data.codpme === "R") setConstancia(false);
        else setConstancia(true);
      } else if (r.data.codpmpol === "cancel") {
        setMsg("Hubo un error, la compra fue cancelada.");
        setConfirmed(false);
        reset();
      } else if (r.data.codpmpol === "mawdy") {
        setMsg("Aceptaste los terminos y condiciones, cuando se procese el pago se te enviará la constancia de adhesión");
        setConfirmed(true);
      } else if (r.data.codpmpol === "mawdyReject") {
        setMsg("Tu pago fue rechazado por la compañía, revisa tu medio de pago");
        setConfirmed(true);
      } else {
        putLogs(url, params, options, r).then((h)=>{})
        setMsg("Se requiere la confirmación por parte del cliente.");
        setConfirmed(false);
      }
      handleShow();
      setLoading(false);
    });
  };

  const downloadConstancia = () => {
    const fileUrl = `${process.env.REACT_APP_BASE_URL}/assets/solicitudseguroPeretti.pdf`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'SolicitudConstancia.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);

  return (
    <>
      <Fade appear in>
        <div className="qs qsmargin">
          <div className="container max-shadow res-confirm">
            <div className="d-flex flex-column m-0  mb-4 scroll-off">
              <h1 className="text-start mx-0 mt-3 fs-5 color-title-blue">
                CONFIRMAR COMPRA
              </h1>
              <p className="m-0 fw-semibold color-title-blue">
                Presupuesto n° {codpmpol}
              </p>
            </div>
            <div className="qs-inputs row row-cols-sm-1 row-cols-lg-2">
              {
                //Mawdy no tiene datos en payMethod
                firstStep.codsec !== 27 &&
                <>
                  <label className="labels color-title-blue">
                    Nombre y Apellido:
                  </label>
                  <label className="labels-info">{payMethod.fullName}</label>
                  <label className="labels color-title-blue">DNI:</label>
                  <label className="labels-info">{payMethod.dni}</label>
                  <label className="labels color-title-blue">Forma de pago:</label>
                  <label className="labels-info">
                    {
                      arrPayMethod.find(
                        (payMethod) =>
                          Number(payMethod.value) === Number(firstStep.payMethod)
                      )?.label
                    }
                  </label>
                  {payMethod.id === 1 ? (
                    <label className="labels">Tarjeta:</label>
                  ) : payMethod.id === 2 ? (
                    <label className="labels">CBU:</label>
                  ) : (
                    <label></label>
                  )}
                  <label className="labels-info">{payMethod.cardNumber}</label>
                </>
              }
              <label className="labels color-title-blue">Pago mensual:</label>
              <label className="labels-info">
                $ {Number(firstStep.price)?.toFixed(2)}
              </label>
            </div>
            {
              company !== 4 &&
              company !== 54 &&
              company !== 6 &&
              company !== 56 &&
              company !== 7 &&
              company !== 57 && 
              company !== 62 &&
              company !== 12 && (
                <Alert className="mt-4" variant={"primary"}>
                  <FontAwesomeIcon icon={faInfoCircle} /> Para confirmar la
                  compra, el usuario deberá aceptar los Términos y Condiciones
                  por SMS. El mensaje le llegará al número{" "}
                  <b>{phone?.length < 10 ? `${area}${phone}` : phone}.</b>
                </Alert>
              )}
            {
              loading ? (
                <SpinnerLoading />
              ) :
                !confirmed ? (
                  <div className="d-grid gap-2 d-md-flex justify-content-lg-end justify-content-md-center mt-4">
                    <Button className="btn btn-primary" onClick={finish}>
                      Verificar Compra
                    </Button>
                    {(company === 12 || company === 62) && (
                      <Button className="btn btn-secondary ms-2" onClick={downloadConstancia}>
                        Descargar Solicitud
                      </Button>
                    )}
                  </div>
                ) : (
                  <div className="d-grid gap-2 d-md-flex justify-content-lg-end justify-content-md-center mt-4">
                    <Button className="btn btn-primary" onClick={reset}>
                      Volver
                    </Button>
                  </div>
                )
            }
          </div>
        </div>
      </Fade>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {show ? "Información de compra" : "Confirmación de compra"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{msg}</Modal.Body>
        <Modal.Footer>
          {(company === 4 || company === 54) &&
            firstStep.codsec === 32 &&
            currentCupPDF !== "" && (
              <Base64Downloader
                base64={currentCupPDF}
                downloadName={`Cuponera`}
                className="btn btn-success"
              >
                Descargar Cuponera
              </Base64Downloader>
            )}
          {(company === 4 || company === 54) &&
            firstStep.codsec === 32 &&
            currentPolPDF !== "" &&
            cerpol !== 0 && (
              <Base64Downloader
                base64={currentPolPDF}
                downloadName={`Poliza`}
                className="btn btn-success"
              >
                Descargar Póliza
              </Base64Downloader>
            )}
          {confirmed && constancia &&
            ((firstStep.codsec !== 32 || (company !== 2 && company !== 52)) && firstStep.codsec !== 27) && (
              <Button
                variant="success"
                href={`https://www.itdepsis.com.ar/ftp/pm/certificados/Constancia_de_Adhesion_Provisoria-${company}${intpol}.pdf`}
                target={"_blank"}
              >
                Ver Certificado
              </Button>
            )}
          <Button
            variant="primary"
            onClick={confirmed ? reset : handleClose /*reset*/}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.mainReducer.user,
    firstStep: state.mainReducer.firstStep,
    payMethod: state.mainReducer.payMethod,
    arrPayMethod: state.mainReducer.arrPayMethod,
    phone: state.mainReducer.titularData.phone,
    area: state.mainReducer.titularData.area,
    codpmpol: state.mainReducer.codpmpol,
    company: state.mainReducer.company,
    titularData: state.mainReducer.titularData
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Confirm);
